module.exports = __webpack_public_path__ + "media/sofia/sofia-color-bf187b02.png";